export const loadingOverlay = () => {
    $('.js-show-overlay').on('submit', (e) => {
        $('.js-overlay').show()
    })
}
